import React from 'react';
import AddEditAttachmentDialog from '../../modules/attachment/AddEditAttachmentDialog';
import EditZoneDialog from 'features/user/pages/EditZoneDialog';
import AddZoneDialog from 'features/user/pages/AddZoneDialog';
import AddEditNameDialog from 'features/user/pages/AddEditNameDialog';
import AddEditCredentialDialog from 'features/user/pages/AddEditCredentialDialog';
import AddEditBulletinDialog from 'features/user/pages/AddEditBulletinDialog';
import { connect } from 'react-redux';
import AddEditPersonDialog from 'features/user/pages/AddEditPersonDialog';
import AddEditAddressPage from 'features/user/pages/AddEditAddressPage';
import AddEditPlaceDialog from 'features/user/pages/AddEditPlaceDialog';
import AddVehicleDialog from 'features/user/pages/AddVehicleDialog';
import EditVehicleDialog from 'features/user/pages/EditVehicleDialog';

const RMSGeneralDialog = (props) => {
  const {
    isAuthenticated,
    personDialogs,
    addressDialogs,
    placeDialogs,
    vehicleDialogs,
    editVehicleDialogs,
    bulletinDialogs,
    credentialDialogs,
    attachmentDialogs,
    editZoneDialogs,
    zoneDialogs,
    personNameDialogs,
  } = props;

  if (!isAuthenticated) return null;

  return (
    <>
      {/* Add/Edit Person dialog */}
      {personDialogs.map((dialog) => (
        <AddEditPersonDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add/Edit Address dialog */}
      {addressDialogs.map((dialog) => (
        <AddEditAddressPage key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add/Edit Place dialog */}
      {placeDialogs.map((dialog) => (
        <AddEditPlaceDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add Vehicle dialog */}
      {vehicleDialogs.map((dialog) => (
        <AddVehicleDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Edit Vehicle dialog */}
      {editVehicleDialogs.map((dialog) => (
        <EditVehicleDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add/Edit person dialog */}
      {personNameDialogs.map((dialog) => (
        <AddEditNameDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add zone dialog */}
      {zoneDialogs.map((dialog) => (
        <AddZoneDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Edit zone dialog */}
      {editZoneDialogs.map((dialog) => (
        <EditZoneDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add/Edit Attachment dialog */}
      {attachmentDialogs.map((dialog) => (
        <AddEditAttachmentDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add/Edit Credential dialog */}
      {credentialDialogs.map((dialog) => (
        <AddEditCredentialDialog key={dialog.requestId} dialog={dialog} />
      ))}

      {/* Add/Edit Bulletin dialog */}
      {bulletinDialogs.map((dialog) => (
        <AddEditBulletinDialog key={dialog.requestId} dialog={dialog} />
      ))}
    </>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  personDialogs: state.personDialog.dialogs,
  addressDialogs: state.addressDialog.dialogs,
  placeDialogs: state.placeDialog.dialogs,
  vehicleDialogs: state.vehicleDialog.dialogs,
  editVehicleDialogs: state.editVehicleDialog.dialogs,
  bulletinDialogs: state.bulletinDialog.dialogs,
  credentialDialogs: state.credentialDialog.dialogs,
  attachmentDialogs: state.attachmentDialog.dialogs,
  editZoneDialogs: state.editZoneDialog.dialogs,
  zoneDialogs: state.zoneDialog.dialogs,
  personNameDialogs: state.personNameDialog.dialogs,
});

export default connect(mapStateToProps)(RMSGeneralDialog);
